<div class="policy" data-testid="mfa-policy-panel">
  <div class="policy__title">{{ 'settings_security.policy.title' | translate }}</div>
  <p class="policy__lede">{{ 'settings_security.policy.lede' | translate }}</p>

  <ui-auth-error-banner *ngIf="error" [error]="error"></ui-auth-error-banner>

  <p class="policy__lede" *ngIf="loading" data-testid="mfa-policy-loading">
    {{ 'settings_security.policy.loading' | translate }}
  </p>

  <ng-container *ngIf="settings">
    <!-- A real state now the panel renders for `access:settings_security`. -->
    <p
      class="policy__notice"
      *ngIf="(canEdit$ | async) === false"
      data-testid="mfa-policy-read-only"
    >
      {{ 'settings_security.policy.read_only' | translate }}
    </p>

    <!-- Informational, and dismissible: neither line is an error, and the
         second one is only worth reading while it names people. -->
    <div class="policy__cards">
      <div class="policy__card" *ngIf="showsCard('coverage')" data-testid="mfa-policy-coverage">
        <span class="policy__card-text">
          {{
            'settings_security.policy.coverage'
              | translate: { enrolled: coverageEnrolled, total: coverageTotal }
          }}
        </span>
        <button
          type="button"
          class="policy__card-dismiss"
          data-testid="mfa-policy-coverage-dismiss"
          [attr.aria-label]="'settings_security.policy.dismiss' | translate"
          (click)="dismissCard('coverage')"
        >
          &times;
        </button>
      </div>

      <div class="policy__card" *ngIf="showsCard('gap')" data-testid="mfa-policy-coverage-gap">
        <span class="policy__card-text">
          {{ 'settings_security.policy.coverage_gap' | translate: { count: coverageGap } }}
        </span>
        <button
          type="button"
          class="policy__card-dismiss"
          data-testid="mfa-policy-coverage-gap-dismiss"
          [attr.aria-label]="'settings_security.policy.dismiss' | translate"
          (click)="dismissCard('gap')"
        >
          &times;
        </button>
      </div>
    </div>

    <!-- At rest a summary, not a form: nothing here holds an unsaved value. -->
    <dl class="policy__summary" data-testid="mfa-policy-summary">
      <div class="policy__row">
        <dt class="policy__label">{{ 'settings_security.policy.mode' | translate }}</dt>
        <dd class="policy__value" data-testid="mfa-policy-summary-mode">{{ policyLabel }}</dd>
      </div>

      <div class="policy__row">
        <dt class="policy__label">{{ 'settings_security.policy.grace_days' | translate }}</dt>
        <dd class="policy__value" data-testid="mfa-policy-summary-grace">
          {{ settings.grace_days }}
        </dd>
      </div>

      <div class="policy__row">
        <dt class="policy__label">{{ 'settings_security.policy.email_otp' | translate }}</dt>
        <dd class="policy__value" data-testid="mfa-policy-summary-email-otp">
          {{ emailOtpLabel }}
        </dd>
      </div>
    </dl>

    <p class="policy__lede" *ngIf="requiredSince" data-testid="mfa-policy-required-since">
      {{ 'settings_security.policy.required_since' | translate: { date: requiredSince } }}
    </p>

    <div class="policy__actions">
      <!-- Rendered for every reader and disabled for the ones the PATCH would
           answer 403: a hidden control reads as "not configurable". -->
      <ui-button
        type="secondary"
        testId="mfa-policy-edit"
        [label]="'settings_security.policy.edit' | translate"
        [disabled]="(canEdit$ | async) === false"
        (click)="openEditor()"
      ></ui-button>
    </div>
  </ng-container>
</div>
